module.exports = __webpack_public_path__ + "static/media/eye.cfd0311d.svg";